export const placeData = {
	title: "Información de contrato",
	description: "Información general de la cuenta",
	loading: "Cargando...",
	accessDenied: {
		title: "Acceso Denegado",
		description: "No tienes permisos para acceder a esta pantalla.",
	},
	error: {
		title: "Error",
		description: "Ocurrió un error al cargar los datos. Inténtalo de nuevo.",
	},
	sections: {
		general: {
			title: "General",
			description: "Información general de la cuenta",
		},
		fees: {
			title: "Tarifas",
			description:
				"Valores representan la tarifa que se aplicará a los elementos siguientes",
		},
		balanceModel: {
			title: "Modelo de saldo",
			description: "Definición de retorno del saldo",
		},
		grabAndGo: {
			title: "Grab and Go",
			description: "Tipo de entrega configurado",
		},
		eventCurrency: {
			title: "Moneda del evento",
			description: "Moneda y proporción utilizada",
		},
		smartPosSettings: {
			title: "Configuraciones de SmartPOS",
			description: "Datos de integración",
		},
		communication: {
			title: "Comunicación",
			description: "Envío de mensajes (SMS y WhatsApp)",
		},
	},
	fields: {
		contractNumber: "Número de contrato",
		profile: "Perfil",
		mainVersion: "Versión principal",
		guaranteedMonthlyMinimum: "Mínimo mensual garantizado",
		monthlyBillingCap: "Tope mensual de facturación",
		zigResponsible: "Responsable ZIG",
		placeStatus: "Estado del local",
		zigLocation: "Ubicación Zig",
		rechargeNotIntegratedLimit: "Límite de recarga no integrada",
		localResponsible: "Responsable(s) del local",
		minVersion: "Versión mínima del PDV",
		placeClassification: "Clasificación del local",
		smsNumbers: "Números para envío de SMS de ingresos",
		serviceFee: "Tarifa de servicio",
		deliveryFee: "Tarifa de entrega",
		processingFee: "Tarifa de procesamiento",
		platformFee: "Tarifa de la plataforma",
		status: {
			active: "Activo",
			blocked: "Bloqueado",
			inactive: "Inactivo",
			paused: "En pausa",
		},
		profileValues: {
			barAndRestaurant: "Bar y Restaurante",
			restaurant: "Restaurante",
			concertHall: "Teatro de Conciertos",
			bar: "Bar",
			nightclub: "Discoteca",
			park: "Parque",
			sportsArena: "Estadio Deportivo",
			other: "Otro",
		},
		parentPlaceName: "Lugar Padre",
		balanceReturnType: "Tipo de retorno del saldo",
		ppuAuthorizationValue: "Valor de la preautorización de la app",
		nonIntegratedPaymentLimit: "Límite de pago no integrado por dispositivo y evento",
		returnPeriod: "Período de retorno",
		minimumBalance: "Saldo mínimo",
		maximumBalance: "Saldo máximo",
		deliveryType: "Tipo de entrega",
		deliveryTime: "Tiempo de entrega",
		deliveryRadius: "Radio de entrega",
		currency: "Nombre",
		exchangeRate: "Proporción a la moneda del país",
		currencySymbol: "Símbolo",
		decimalPlaces: "Lugares decimales",
		integrationStatus: "Estado de integración",
		apiVersion: "Versión de API",
		lastSync: "Última sincronización",
		syncFrequency: "Frecuencia de sincronización",
		smsCost: "Costo del envío",
		whatsappCost: "Costo del envío",
		whatsappNumber: "Número",
		whatsappId: "ID del servicio",
		pushNotifications: "Notificaciones push",
		placeType: "Tipo de Place",
		placeTypesValues: {
			default: "Predeterminado",
			delivery: "Entrega",
			transfers: "Transferencias",
			advance: "Anticipo",
			billing: "Facturación",
		},
		accountType: "Tipo de cuenta",
		accountTypes: {
			conta_corrente: "Corriente",
			conta_poupanca: "Ahorro",
			conta_salario: "Nómina",
		},
		house: "Casa",
		zigFeeShouldBeChargedInDebit: "Cobrar tarifa Zig en la fecha de débito",
		hasCustomizedCard: "El depósito de garantía es del cliente",

		deliveryPlatforms: {
			ifood: {
				brandName: "IFood",
				settlementDays: "Días hasta la liquidación de IFood",
				fee: "Tarifa iFood",
				description: "Configuraciones de IFood",
			},
		},
		delveryOnlineRules: "Reglas de entrega en línea",
		chargeBack: "Expirar al final del evento",
		placeOnly: "Gestionadas por la casa",
		normal: "Gestionadas por Zig",
		// Tasas y valores
		rateType: "Tipo",
		rateTypeLabel: "Tipo de tasa",
		singleRate: "Tasa única",
		segmentedFeeType: "Tasa segmentada",
		singleFeeType: "Tasa única",
		systemFee: "Tasa del sistema",
		inHouseConsumption: "Consumo en casa",
		ticketOfficeRevenue: "Ingresos de taquilla",
		rechargeSurplus: "Excedente de recarga",
		bonus: "Bonus",
		fixedFee: "Tasa fija",
		appFee: "Tasa sobre app",
		prechargeOnlinePaymentFee: "Tasa de pre-carga/pago en línea",
		fixedFeePaymentDay: "Día de pago de la tasa fija",
		anticipationFee: "Tasa de anticipación",
		thirdPartyPaymentFee: "Tasa de pago de terceros",
		// Pago con máquina ZigPay
		zigPayMachinePayment: "Pago con máquina ZigPay",
		debit: "Débito",
		credit: "Crédito",
		creditOtherFlags: "Crédito (Otras banderas)",
		debitOtherFlags: "Débito (Otras banderas)",
		replicateRatesForAllFlags: "¿Replicar tasas para todas las banderas?",
		pix: "Pix",
		pixKey: "Clave Pix",
		pixKeyType: "Tipo de Clave PIX",
		yes: "Sí",
		// Vale de alimentación
		foodVoucher: "Vale de alimentación",
		// Pago con máquina integrada en EC del cliente
		integratedMachinePayment: "Pago con máquina integrada en EC del cliente",
		machineCommission: "Comisión de las máquinas",
		anticipatedConsumption: "Consumo anticipado",
		anticipatedBar: "Anticipado/Bar",
		ticketOffice: "Taquilla",
		// Días hasta la cobranza
		daysUntilCollection: "Días hasta la cobranza",
		daysUntilCollectionDescription:
			"Cantidad de días para ejercer la cobranza y pagos en los siguientes formatos",
		collectionDaysDescription:
			"Cantidad de días para ejercer la cobranza y pagos en los siguientes formatos",
		// Parcelamiento
		installment: "Parcelamiento",
		installmentFee: "Tasa de parcelamiento",
		maxInstallments: "Número máx. de cuotas",
		bankAccountData: "Datos de cuenta bancaria",
		receivingAccount: "Compte de réception",
		recharges: "Recargas",
		rechargeValidityCriteria: "Validez y criterios de recarga",
		rechargesExpireIn: "Las recargas expiran en",
		remainingRechargeActions: "Acciones del saldo de recarga",
		digit: "Dígito",
		accountIdentification: "Identificación de la cuenta",
		accountIdentifier: "Identificador de la cuenta",
		cpfCnpj: "CPF/CNPJ",
		registrationData: "Datos para registrar",
		bankData: "Datos bancarios",
		branch: "Sucursal",
		bank: "Banco",
		account: "Cuenta",
		accountHolder: "Titular de la cuenta",
		documentType: "Tipo de documento",
		onlineDeliveryFee: "Tarifa de delivery online",
		advanceReservationFee: "Tarifa de cobranza anticipada en reservas",
		notApplicable: "No se aplica",
	},
};
